/* eslint-disable max-len */
import React from 'react';
// import { log } from '#emyw/core-lib';

const EnjoyIcon = props => {
  const {
    className,
    style,
    secondaryColor,
    basic
  } = props;
  const random = Math.floor(Math.random() * 10000);
  // log.trace('hello world');
  return /*#__PURE__*/React.createElement("span", {
    className: 'enjoyIcon'.concat(className ? " ".concat(className) : ''),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    width: "1em",
    viewBox: basic ? '0 0 22.5 22.5' : '0 0 117.92948 130.65334',
    style: {
      transform: 'translateY(0.15em)'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient1".concat(random),
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.709739,-4.5160811,1.8326519,-1.0996276,196.94747,1066.4503)",
    cx: "144.08546",
    cy: "194.88159",
    fx: "144.08546",
    fy: "194.88159",
    r: "53.856518"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.05701577"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.48185223"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.49705821"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.98057425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2".concat(random),
    gradientUnits: "userSpaceOnUse",
    x1: "239.36877",
    y1: "283.83188",
    x2: "360.62851",
    y2: "485.03564"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.14458823",
    style: {
      stopColor: '#000'
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.46900943",
    style: {
      stopColor: '#fff'
    }
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.47686026"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.82988507"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient3".concat(random),
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.4206575,-1.3830464,3.0454054,-5.3301783,-615.11599,2590.978)",
    cx: "154.49635",
    cy: "378.5535",
    fx: "154.49635",
    fy: "378.5535",
    r: "53.959072"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.04493233"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.40511799"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.41377157"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.81851608"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient4".concat(random),
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.7529542,7.5486049e-7,-2.9911554e-7,2.585189,-1689.2541,-442.60982)",
    cx: "345.97031",
    cy: "278.57761",
    fx: "345.97031",
    fy: "278.57761",
    r: "54.928303"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.04812159"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.41093951"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.42257258"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.8304947"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5".concat(random),
    gradientUnits: "userSpaceOnUse",
    x1: "219.02963",
    y1: "278.35938",
    x2: "337.09479",
    y2: "69.273689"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.19914617"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.5126791"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.52242792"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.85042578"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6".concat(random),
    gradientUnits: "userSpaceOnUse",
    x1: "-30",
    y1: "297.51968",
    x2: "180",
    y2: "297.51968"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.1131653"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.50715989"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "0.51841688"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0.87078685"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7".concat(random),
    x1: "100.14969",
    y1: "588.53107",
    x2: "100.14969",
    y2: "-173.46896",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: 'currentColor'
    },
    offset: "0.50348777"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient8".concat(random),
    x1: "147.77469",
    y1: "588.53107",
    x2: "147.77469",
    y2: "-173.46896",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#000'
    },
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: secondaryColor
    },
    offset: "0.50348777"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: '#fff'
    },
    offset: "1"
  }))), basic ? /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0081491,0,0,1.0081491,-3.4370349,-5.6671494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.740625,12.47207 c -0.06705,-0.0017 -0.133298,0.01533 -0.191406,0.04883 -1.253129,0.721006 -2.237918,1.292781 -3.384375,1.954883 v 8e-4 c -0.07962,0.04821 -0.128711,0.134396 -0.128711,0.227735 0,0.09334 0.04909,0.179336 0.128711,0.227539 v 6e-4 c 0.712095,0.41139 1.51705,0.876021 2.158594,1.24668 0.255603,0.147731 0.351592,0.348444 0.351562,0.542968 -3e-5,0.194524 -0.09573,0.395244 -0.351562,0.542969 -0.829694,0.481911 -1.490222,0.854452 -2.274805,1.307227 l -2e-4,2e-4 c -0.08223,0.04765 -0.133006,0.135604 -0.133008,0.230664 0,0.09519 0.05078,0.183058 0.133203,0.230664 1.25624,0.726158 2.466623,1.421322 3.501953,2.020313 0.113207,0.06531 0.252611,0.06531 0.36582,0 0.746578,-0.428211 1.584183,-0.911934 2.319141,-1.335938 2.206769,-1.224211 2.194072,-4.684775 0,-5.857422 -0.845912,-0.488187 -1.52863,-0.882847 -2.320508,-1.339844 -0.05315,-0.03065 -0.113076,-0.04751 -0.174414,-0.04883 z m -3.832031,7.165625 c 0.01578,0.01779 0.03336,0.03401 0.05273,0.04844 -0.01933,-0.01439 -0.03698,-0.0307 -0.05273,-0.04844 z",
    style: {
      fill: secondaryColor
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.139844,5.622266 C 6.258178,5.578096 4.679309,7.120905 4.678906,9.003125 v 15.572266 c 4e-4,2.53897 2.871322,4.196807 5.070313,2.927734 7e-4,2e-6 0.00125,2e-6 0.00195,0 3.416044,-1.975176 6.834644,-3.944732 10.251562,-5.917383 v -2e-4 c 0.07962,-0.04821 0.128516,-0.134197 0.128516,-0.227539 0,-0.09334 -0.0489,-0.179532 -0.128516,-0.227735 v -2e-4 c -1.175831,-0.680385 -2.368584,-1.366159 -3.506054,-2.022656 -0.05315,-0.03066 -0.113077,-0.04731 -0.174414,-0.04863 -0.06705,-0.0017 -0.133299,0.01513 -0.191407,0.04863 -2.174702,1.255472 -4.242047,2.449903 -6.549609,3.782436 -0.255706,0.147486 -0.476032,0.128557 -0.644531,0.03125 -0.168499,-0.09731 -0.294802,-0.280935 -0.294922,-0.576172 v -3.292969 c 2.9e-5,-0.0026 2.9e-5,-0.0052 0,-0.0078 5.3e-5,-0.03829 0.019464,-0.07286 0.052734,-0.0918 3.739972,-2.158441 7.581806,-4.377872 11.286133,-6.515821 v -2e-4 c 0.07962,-0.04821 0.128711,-0.134393 0.128711,-0.227734 0,-0.09334 -0.04909,-0.179335 -0.128711,-0.227539 C 16.57001,10.012149 13.16101,8.044938 9.749216,6.075416 9.308212,5.84075 8.774522,5.627708 8.139841,5.622291 Z m 1.144531,4.847656 c 0.10531,0.0024 0.207672,0.03139 0.298828,0.08398 l 4.528125,2.614453 c 0.149045,0.07505 0.146925,0.251606 0.01836,0.323047 l -5.192579,2.998047 c -0.130326,0.06682 -0.291371,0.01651 -0.295312,-0.172851 v -5.219727 c 10e-5,-0.383444 0.259061,-0.635935 0.642578,-0.626953 z",
    style: {
      fill: 'currentColor'
    }
  })) : /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.75549386,-0.35190248)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.47753,-140.02581)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.417734,131.71042)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "M 108.04688,32.777344 C 69.541157,31.873508 37.193786,63.461573 37.185547,101.97852 v 0.004 3.8164 c 0,0 49.788305,27.71187 74.638813,41.69137 0.003,-0.0292 0.006,-0.0585 0.009,-0.0877 1.16266,-11.66051 10.66734,-20.17325 22.72775,-19.89081 v -0.004 c 3.62987,0.085 7.17186,1.05672 10.33789,2.82031 V 44.261719 l -3.86524,-2.232422 h -0.008 c -10.0433,-5.796773 -21.38694,-8.978554 -32.98242,-9.25 z",
    style: {
      fill: "url(#radialGradient1".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "m 374.21488,292.35932 c -0.9476,1.30748 -4.46918,4.17951 -6.51567,5.25982 l -55.35547,31.95898 -0.67383,0.38868 c -0.003,9.8e-4 -0.004,0.002 -0.008,0.004 -1.87827,1.08839 -3.03512,3.09433 -3.03516,5.26563 0,2.17425 1.16023,4.18411 3.04297,5.27148 0,0 0.45772,0.26376 0.67383,0.38867 v 0.006 l 61.32031,35.40235 c 0.0903,0.0521 1.90625,1.10156 1.90625,1.10156 2.58571,1.49166 5.76967,1.49166 8.35547,0 0,0 2.33351,-1.34783 2.50586,-1.44727 l 62.63867,-36.1621 v -0.004 c 1.01869,-0.58837 2.79153,-1.69011 3.73284,-2.33614 -26.11009,-14.64016 -52.93009,-30.73249 -78.58807,-45.09766 z m -79.03716,48.54498 c -1.53154,-0.0378 -3.04384,0.34807 -4.37109,1.11328 0,0 -1.2248,0.70596 -1.26562,0.73242 v -0.004 l -145.66382,84.09403 -0.78809,89.60322 2.82487,-1.62059 217.27354,-125.43985 v -0.002 c 1.81863,-1.10109 2.93945,-3.0691 2.93945,-5.20117 0,-2.13207 -1.12082,-4.09817 -2.93945,-5.19922 v -0.004 l -61.25586,-35.36523 -0.002,0.002 c -0.20788,-0.12019 -2.76758,-1.5957 -2.76758,-1.5957 -1.21406,-0.70027 -2.58339,-1.08305 -3.98438,-1.11328 z",
    style: {
      fill: "url(#linearGradient2".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "m 111.87109,409.65625 -74.685488,41.80867 v 6.2168 0.004 c 0.0076,51.95845 58.843104,85.92764 103.843748,59.95703 l 0.008,-0.004 4.05859,-2.35546 -0.0176,-89.13096 c 0,0 -0.30625,0.16453 -0.36954,0.19946 -15.00707,8.28267 -31.06911,-0.21025 -32.82756,-16.60146 l -0.0102,-0.0941 z",
    style: {
      fill: "url(#radialGradient3".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "m 449.49205,220.14684 -76.93038,42.37924 c 0,0 0.59169,0.53671 1.01365,0.98474 8.40473,8.73409 8.19736,21.65064 -0.62608,30.17871 l 5.8125,3.25391 c 0.0355,0.0155 0.0754,0.0338 0.10937,0.0527 0,0 3.60553,2.01723 3.89844,2.18164 l 0.008,-0.004 69.2793,38.77148 c 0.25718,-0.1667 0.50493,-0.32312 0.75888,-0.49267 40.8946,-27.30382 39.96587,-91.35621 -2.7841,-116.99212 -0.0312,-0.019 -0.50827,-0.29495 -0.53958,-0.31363 z",
    style: {
      fill: "url(#radialGradient4".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "m 142.76967,43.035616 -0.0312,86.226314 c 0.43528,0.18176 1.99474,0.94911 2.45686,1.22635 l 107.42383,62.02344 c 6.33575,3.85067 6.32933,13.04873 -0.0117,16.89062 l -63.73437,36.79493 14.90429,25.98632 158.94336,-91.75586 v -0.002 c 1.81856,-1.10109 2.93946,-3.06914 2.93946,-5.20117 0,-2.13207 -1.1209,-4.09821 -2.93946,-5.19922 z M 37.185547,105.70898 v 172.5254 h 0.002 z m 342.292973,75.17967 c -1.53086,-0.0374 -3.04247,0.34844 -4.36914,1.11328 0,0 -1.22676,0.70597 -1.26758,0.73243 v -0.008 l -60.05664,34.67383 v 0.0156 c -1.81867,1.10109 -2.93946,3.06917 -2.93946,5.20117 0,2.13207 1.12079,4.0982 2.93946,5.19922 v 0.0117 l 53.92578,31.13477 c 2.11126,1.22024 3.94063,2.63109 5.49454,4.17968 l 0.28281,0.2754 76.48241,-42.99396 c 0,0 -0.11727,-0.0699 -0.15916,-0.0952 -22.03163,-12.76218 -44.65213,-25.80442 -63.57912,-36.73293 l -0.004,0.002 c -0.20788,-0.12019 -2.76563,-1.59571 -2.76563,-1.59571 -1.2135,-0.69987 -2.58211,-1.08273 -3.98242,-1.11328 z",
    style: {
      fill: "url(#linearGradient5".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.26458333)",
    d: "m 37.097159,100.93597 0.09399,352.35196 74.738511,-42.95197 c 0,0 -0.0637,-0.72679 -0.0656,-0.75029 -0.0935,-0.91984 -0.15055,-1.86007 -0.15095,-2.82782 v -0.004 -75.25 c -0.003,-0.0566 -0.006,-0.11327 -0.008,-0.16993 0.005,-3.73167 2.01043,-7.17418 5.2539,-9.01953 v -0.008 l 87.24805,-50.36914 -14.97851,-25.94336 -62.79102,36.25195 c -6.51376,3.66862 -14.58426,-0.94737 -14.72461,-8.42187 V 149.822 149.818 c 2.2e-4,-0.76062 0.0355,-1.51031 0.10373,-2.24753 0.002,-0.0269 0.24393,-1.80295 0.24393,-1.80295 z",
    style: {
      fill: "url(#linearGradient6".concat(random, ")")
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 66.005109,140.38272 c -10.18797,-0.23914 -18.746536,8.11853 -18.748716,18.30947 a 7.3279643,7.3279643 0 0 0 0,10e-4 v 94.11206 a 7.3279643,7.3279643 0 0 0 0,0.001 c 0.002,13.74734 15.568896,22.73504 27.475316,15.86365 a 7.3279643,7.3279643 0 0 0 0.0021,-10e-4 l 58.777141,-33.93437 v -5.3e-4 c 0.48118,-0.29133 0.77773,-0.81203 0.77773,-1.37614 0,-0.56411 -0.29655,-1.08431 -0.77773,-1.37563 v -10e-4 l -16.20727,-9.35705 -5.3e-4,5.3e-4 c -0.055,-0.0318 -0.73225,-0.42219 -0.73225,-0.42219 -0.32122,-0.18528 -0.68352,-0.28656 -1.0542,-0.29456 -0.40522,-0.01 -0.80535,0.0921 -1.15652,0.29456 0,0 -0.32406,0.18678 -0.33486,0.19378 v -0.001 l -38.193029,22.05146 c -4.241519,2.44642 -8.855339,-0.21817 -8.857339,-5.11493 v -0.001 -19.9099 a 2.7500001,2.7500001 0 0 1 -0.002,-0.045 2.7500001,2.7500001 0 0 1 1.3901,-2.38641 v -0.002 l 65.024518,-37.53906 v -5.3e-4 c 0.48116,-0.29133 0.77773,-0.81205 0.77773,-1.37615 0,-0.56411 -0.29657,-1.08431 -0.77773,-1.37562 l -58.6548,-33.86553 a 7.3279643,7.3279643 0 0 0 -0.0021,0 c -2.657291,-1.53373 -5.658391,-2.37558 -8.726361,-2.4474 z m 7.01508,25.0641 c 0.99021,0.0232 1.956601,0.29398 2.813779,0.78858 l 28.422542,16.41037 a 2.6137142,2.6137142 0 0 1 -0.003,4.46898 l -33.382451,19.27324 a 2.6137142,2.6137142 0 0 1 -3.89588,-2.22829 v -32.80885 -0.001 c 0.001,-3.4079 2.63758,-5.98177 6.04511,-5.90197 z",
    style: {
      opacity: '0.95',
      fill: "url(#linearGradient7".concat(random, ")")
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 137.82192,179.57051 c -0.40521,-0.01 -0.80534,0.0921 -1.15651,0.29455 0,0 -0.32459,0.18679 -0.33539,0.19379 v -0.002 l -15.88998,9.17412 v 0.004 c -0.48119,0.29133 -0.77773,0.81206 -0.77773,1.37615 0,0.56411 0.29654,1.08431 0.77773,1.37562 v 0.003 l 14.26787,8.23774 c 4.23948,2.45029 4.2397,7.77815 -0.003,10.2278 l -14.64614,8.45581 -0.17828,0.10283 c -8e-4,2.6e-4 -10e-4,5.3e-4 -0.002,10e-4 -0.49696,0.28797 -0.80305,0.8187 -0.80306,1.39319 0,0.57527 0.30698,1.10705 0.80512,1.39475 0,0 0.1211,0.0698 0.17828,0.10285 v 0.002 l 16.22434,9.36686 c 0.0239,0.0138 0.50436,0.29146 0.50436,0.29146 0.68413,0.39467 1.52655,0.39467 2.21071,0 0,0 0.61741,-0.35662 0.66301,-0.38293 l 16.57325,-9.56799 a 7.3279643,7.3279643 0 0 0 0,-10e-4 c 11.90411,-6.87557 11.9039,-24.85047 0,-31.72622 a 7.3279643,7.3279643 0 0 0 0,-0.001 l -16.62587,-9.59994 -0.001,5.3e-4 c -0.055,-0.0318 -0.73174,-0.42219 -0.73174,-0.42219 -0.32122,-0.18526 -0.68352,-0.28656 -1.0542,-0.29456 z",
    style: {
      opacity: '0.95',
      fill: "url(#linearGradient8".concat(random, ")")
    }
  })))));
};
EnjoyIcon.defaultProps = {
  className: null,
  style: null,
  secondaryColor: '#c6c6c6',
  basic: false
};
export default EnjoyIcon;